module.exports = __webpack_public_path__ + "static/media/coaches.1e0ae034.svg";